module.exports = "https://img1.huilianyi.com/8/create-app@3x.88a00a6357.appcore.png";